<script>
import catalog from '@/mixins/catalog';
import listingBase from '@/mixins/listing-base';

const PopupProduct = () => import ('@/components/popup-product');
const ListingCardMobile = () => import ('@/components/listing-card-mobile');

export default {

  name: 'listing-search-mobile',
  components: {"listing-card": ListingCardMobile, "popup-product": PopupProduct},
  props: ['allParams'],  
  mixins: [catalog, listingBase],
  //template: '#location',
  data: function(){

      return {
        smartFilterParams:[],
        searchIds:[],
        loading: false,
        nextPage: false,
        search:"",
        searchIds:[],
        arResult:{"ITEMS":[]},
        category:0,
        mode:"filterShops",
        sections:[],
        activeCategoryId:false,
        filtredProducts:[],
        activeSearch:false,
        lastSearch:""
      }
  },   

  beforeDestroy() {
    // Удаляем обработчик при уничтожении компонента
    document.removeEventListener('click', this.handleClickOutside);
  },

  mounted: function () {

    //console.log(this.allParams);
    //this.offerActive = this.item.CUSTOM_OFFERS[0];

   
        let vue = this;
        document.addEventListener('click', this.handleClickOutside);

        if(!this.isSearch)
        {
            this.countLine = 48;
            window.bus.$on('search', (params) => {

            //vue.searchIds = params;
           // console.log(params);
            vue.mode = "searchQuery";
            vue.activeSearch = params.active;
            

            if(vue.lastSearch !== params.query)
            {
              vue.searchInput({query: params.query});
              // Добавляем обработчик кликов на документ
              
              vue.lastSearch = params.query;
            }
            

            //vue.smartFilterUse();
            });
        }

       


        //this.arResult = JSON.parse(this.arResult);


        if(this.arResult["ITEMS"])
        {
            this.prepareImages();
            //this.arResult["ITEMS"] = 
        }



 },


  methods: {


    closePopup(){


        this.activeSearch = false;

    },


    handleClickOutside(event) {

      const inputField = document.getElementById('completeInput');
      const window = document.getElementById('popupComplete');

      //console.log(event);
      // Если нажата клавиша Enter, не закрываем окно
      if (event.target.closest('.button-send')) {
            return;
        }

      //console.log("клик снаружи");
      // Проверяем, был ли клик вне поля ввода и окна
      if (
        inputField &&
        window &&
        !inputField.contains(event.target) &&
        !window.contains(event.target)
      ) {
        this.activeSearch = false; // Скрываем окно
      }

    },

    runFilterProducts()
    {
            // console.log("test");
            // console.log(this.activeCategoryId);
       
            if (!this.activeCategoryId)
            {
                
                this.filtredProducts = this.arResult.ITEMS; // Показываем все, если категория не выбрана

            }
            else
            {
                this.filtredProducts = this.arResult.ITEMS.filter(product => product.IBLOCK_SECTION_ID === this.activeCategoryId);
            }


            let products = [];
       
            const activeCategory = this.sections.find(section => section.ID == this.activeCategoryId);
            const categoryName = activeCategory ? activeCategory.NAME : "all";

   
            this.arResult.ITEMS.forEach(function (item, i, arr) {

                    let product = {
                        "id": item.ID,
                        "name": item.NAME,
                        "price": parseInt(item.PRICE),
                        "category": categoryName,
                        "list": "search",
                        "position": i + 1
                    };

                    products.push(product);

                });

                this.$ecommerce.viewItemList(products, "search");

            
    },

    getProductsCountByCategory() {
        // Создаем объект для хранения количества товаров по каждой категории
        const categoryCount = {};

        this.sections.unshift({"ID": 0, "NAME": "Все категории"});
        // Проходим по всем товарам
        this.arResult.ITEMS.forEach(product => {
            const categoryId = product.IBLOCK_SECTION_ID;

            // Если категория уже есть в объекте, увеличиваем счетчик
            if (categoryCount[categoryId]) {
                categoryCount[categoryId]++;
            } else {
                // Если категории нет в объекте, добавляем ее с начальным значением 1
                categoryCount[categoryId] = 1;
            }
        });

        // Добавляем количество товаров к каждой категории из sections
        this.sections.forEach(section => {
            section.productCount = categoryCount[section.ID] || this.arResult.ITEMS.length;
        });

    },

    setActiveSection(section)
    {
        this.activeCategoryId = section.ID;
        this.runFilterProducts();
    },


  }

}



</script>

<template>
    <div class="listing" v-if="activeSearch" id="popupComplete">
        <popup-product :item="addProduct">
        </popup-product>
        <div class="close-complete" @click="closePopup">
            X
        </div>
        <div class="flex-block" v-if="!loading">
            <div class="sections-search" v-if="arResult.ITEMS">
                <ul>
                    <li v-for="section in sections" class="section-complete" :class="{active: section.ID == activeCategoryId}" 
                        @click="setActiveSection(section)">
                        {{ section.NAME }} ({{ section.productCount }})
                    </li>
                </ul>
            </div>
            <div id="sc-bot" class="just-sp-btw list-products" v-if="arResult.ITEMS">
                <div class="shops-bor-cart" v-for="item in filtredProducts" :style="{width:countLine+'%'}" :key="item.ID">
                    <listing-card :item="item" @add-product="addProductHandler"></listing-card>
                </div>    
            </div>
        </div>

       
        <div class="row">
            <div class="col-xl-12">
                <div class="loader" v-show="loading">
                    <img :src="allParams.pathTheme+'/images/loader.gif'" alt=""> 
                </div>
              
            </div>
        </div>
   
    </div>
   
    
</template>

